var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 8,
    viewBox: "0 0 22 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4288 2.6C15.5788 0.99 13.1788 0 10.5288 0C6.36883 0 2.78883 2.42 1.08883 5.93C0.768833 6.6 1.12883 7.4 1.83883 7.64C2.42883 7.84 3.06883 7.56 3.33883 7C4.63883 4.34 7.36883 2.5 10.5288 2.5C12.4788 2.5 14.2588 3.22 15.6488 4.38L13.7388 6.29C13.1088 6.92 13.5488 8 14.4388 8H20.0288C20.5788 8 21.0288 7.55 21.0288 7V1.41C21.0288 0.52 19.9488 0.07 19.3188 0.7L17.4288 2.6Z",
    fill: "#9297A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.8d78d6464dabd60336c307492caa05f9.svg";
export { ForwardRef as ReactComponent };